"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radium = _interopRequireDefault(require("radium"));

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _Widget = _interopRequireDefault(require("./Widget"));

var _constants = require("./constants");

var _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("./styles/index.less");

var styles = {
  "screenSmMax": "767px",
  "root": "meepshop-meep-ui__block-index__root",
  "block": "meepshop-meep-ui__block-index__block"
};

var Block = (0, _DecoratorsRoot.enhancer)(_class = (0, _radium["default"])(_class = (_temp = _class2 = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Block, _React$PureComponent);

  var _super = _createSuper(Block);

  function Block() {
    (0, _classCallCheck2["default"])(this, Block);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Block, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          maxWidth = _this$props.width,
          blocks = _this$props.blocks,
          flattenedWidgets = _this$props.flattenedWidgets,
          product = _this$props.product,
          hiddenModules = _this$props.hiddenModules;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.root,
        style: {
          maxWidth: !maxWidth ? '100%' : "".concat(maxWidth, "px")
        }
      }, blocks.map(function (_ref) {
        var id = _ref.id,
            widgets = _ref.widgets,
            width = _ref.width,
            componentWidth = _ref.componentWidth,
            padding = _ref.padding;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: id,
          id: "block-".concat(id),
          className: styles.block,
          style: {
            width: "".concat(width || 100, "%"),
            minWidth: "".concat(componentWidth, "px")
          }
        }, /*#__PURE__*/_react["default"].createElement("style", {
          dangerouslySetInnerHTML: {
            __html: "\n                  #block-".concat(id, " {\n                    padding: ").concat(padding / 2, "px;\n                  }\n                  @media (max-width: ").concat(styles.screenSmMax, ") {\n                    #block-").concat(id, " {\n                      padding: ").concat(padding / 4, "px;\n                    }\n                  }\n                ")
          }
        }), (widgets || []).map(function (_ref2, index) {
          var widgetId = _ref2.id,
              data = (0, _objectWithoutProperties2["default"])(_ref2, ["id"]);
          return /*#__PURE__*/_react["default"].createElement(_Widget["default"], (0, _extends2["default"])({}, data, {
            key: widgetId || "".concat(id, "-").concat(index),
            id: widgetId,
            flattenedWidgets: flattenedWidgets,
            hiddenModules: hiddenModules,
            widgetSetting: {
              componentWidth: componentWidth,
              padding: padding,
              level: 1,
              product: product
            }
          }));
        }));
      }));
    }
  }]);
  return Block;
}(_react["default"].PureComponent), (0, _defineProperty2["default"])(_class2, "propTypes", {
  width: _propTypes["default"].number,
  blocks: _constants.BLOCKS_TYPE.isRequired,
  hiddenModules: _propTypes["default"].arrayOf(_propTypes["default"].string)
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  width: null,
  hiddenModules: []
}), _temp)) || _class) || _class;

exports["default"] = Block;